var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:_vm.computedClass,attrs:{"type":_vm.type,"disabled":_vm.disabled},on:{"click":_vm.click}},[(_vm.busy)?_c('img',{staticClass:"busy-loading-icon",attrs:{"src":require("../assets/loader.svg")}}):_vm._e(),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }